$(function () {
    var searchTemplate = $(".search-results-template");

    if (searchTemplate.length) {
        // Selectors
        var searchInput = $(".search-input");
        var searchButton = $(".search-button");

        // Search Results
        var searchResultsContainer = $(".search-results-list");
        var searchResultsList = $(".search-results-list ul");

        // Pager Variables
        var pagerCon = $(".search-results-meta .paging");
        var pagerPageSize = $(searchResultsList).data("search-pagesize");
        var pagerFullCount = $(searchResultsList).data("search-full-count");
        var pagerPage = $(searchResultsList).data("search-page");

        // Generate pager
        RebuildPager();

        // Reset the news when the search button is clicked
        $(searchButton).click(function () {
            ResetSearch();
        });

        $('.search-options-button .btn').click(function () {
            SearchUpdate(0);
        })

        // Resets the news back to the first page which is triggered when a search is done
        function ResetSearch() {
            // Update the pager
            $(searchResultsList).data("search-page", 0);
            $(searchResultsList).data("search-page", 0);

            // Update the click
            SearchUpdate(0);
        }

        // Updates the news items based on current values
        function SearchUpdate(pagerPageTemp) {
            var SearchModel = {};
            SearchModel.Page = pagerPageTemp;
            SearchModel.PageSize = $(searchResultsList).data("search-pagesize");
            SearchModel.SearchTerm = $(searchInput).val();
            SearchModel.OrderBy = $("input[name='filterSort']:checked").val();

            pagerUrl = $(searchResultsList).data("search-url");

            var url = pagerUrl + "?api=true" +
                (SearchModel.Page > 0 ? "&page=" + SearchModel.Page : "") +
                (SearchModel.PageSize > 0 ? "&pagesize=" + SearchModel.PageSize : "") +
                (SearchModel.SearchTerm != undefined && SearchModel.SearchTerm != "" ? "&search=" + SearchModel.SearchTerm : "") +
                (SearchModel.OrderBy != undefined && SearchModel.OrderBy != "" ? "&orderby=" + SearchModel.OrderBy : "");

            $.get(url, function (data) {
                // Add the returned information to the search results list.
                $(searchResultsContainer).html(data);

                // Reinitialise the variables based on the new list
                searchResultsList = $(".search-results-list ul");
                pagerPageSize = $(searchResultsList).data("search-pagesize");
                pagerFullCount = $(searchResultsList).data("search-full-count");
                pagerPage = $(searchResultsList).data("search-page");

                // Update text content
                if (pagerFullCount > 0) {
                    $('.search-results-body-row').removeClass('search-results-hidden');
                } else {
                    $('.search-results-body-row').addClass('search-results-hidden');
                }

                RebuildPager();

                $('html, body').animate({
                    scrollTop: $('.search-results-body-row').offset().top - 150
                }, 500);
            });
        }

        /* ##### PAGER ##### */

        // Rebuilds the pager
        function RebuildPager() {

            // Clear the pager
            $(pagerCon).html("");

            // Get the maximum pages
            var maxPages = Math.ceil(pagerFullCount / pagerPageSize);

            if (maxPages > 1) {
                // Create the first link
                //if (pagerPage > 1) {
                //    $(pagerCon).append("<li><a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link\" data-search-page=\"0\"><i class=\"fas fa-angle-double-left\"></i></a></li>");
                //}

                // Create previous page link
                if (pagerPage > 0) {
                    $(pagerCon).append("<a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link page-direction\" data-search-page=\"" + (pagerPage - 1) + "\"><em class=\"fas fa-chevron-left\"></em></a>");
                } else {
                    // This is taken out of this pager as we do not want to show diabled elements
                    $(pagerCon).append("<a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link page-direction disabled\"><em class=\"fas fa-chevron-left\"></em></a></li>");
                }

                // Create the previous dots link
                //var previousDotsPage = pagerPage == maxPages - 1 ? pagerPage - 3 : pagerPage - 2;
                //if (previousDotsPage >= 0) {
                //    $(pagerCon).append("<li><a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link\" data-search-page=\"" + previousDotsPage + "\">...</a></li>");
                //}

                // Create the three middle elements
                // We need to get the starting number for the 3 pager item, this is not always 1
                var startingNumber = pagerPage == 0 ? 0 : pagerPage - 1;

                // If we are on the last page we need to offset the start by 2, BUT only if we are not also next to the first page
                startingNumber = pagerPage > 1 && pagerPage == (maxPages - 1) ? pagerPage - 2 : startingNumber;
                // Loop through 3 times from the starting number and output the correct links
                for (var pc = startingNumber; pc <= startingNumber + 2; pc++) {
                    // Only if the current number is less than the max pages
                    if (pc < maxPages) {
                        $(pagerCon).append("<a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link" + (pagerPage == pc ? " active" : "") + "\" data-search-page=\"" + pc + "\">" + (pc + 1) + "</a>");
                    }
                }

                // Create the next dots link
                //var nextDotsPage = pagerPage == 0 ? pagerPage + 3 : pagerPage + 2;
                //if (nextDotsPage <= maxPages - 1) {
                //    $(pagerCon).append("<li><a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link\" data-search-page=\"" + nextDotsPage + "\">...</a></li>");
                //}

                // Create the next link
                if (pagerPage < maxPages - 1) {
                    $(pagerCon).append("<a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link page-direction\" data-search-page=\"" + (pagerPage + 1) + "\"><em class=\"fas fa-chevron-right\"></em></a>");
                } else {
                    // This is taken out of this pager as we do not want to show diabled elements
                    $(pagerCon).append("<a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link page-direction disabled\"><em class=\"fas fa-chevron-right\"></em></a>");
                }

                // Create the last link
                //if (pagerPage < maxPages - 2) {
                //    $(pagerCon).append("<a href=\"javascript:void(0);\" rel=\"nofollow\" class=\"page-link\" data-search-page=\"" + (maxPages - 1) + "\"><i class=\"fas fa-angle-double-right\"></i></a></li>");
                //}
            }

            // Rebind clicks
            $(".paging .page-link").click(PageLinkClick);
        }

        // When a pager button is clicked
        function PageLinkClick() {
            // Turn on the overlay
            $(".search-list-wrapper .overlay").addClass("active"); // NEED TO ADD THIS
            var pagerPageLink = this;
            var pagerPageTemp = $(pagerPageLink).data("search-page");
            SearchUpdate(pagerPageTemp);
        }
    }
});